import {
  // DATA VISUALIZATION / CHARTS
  tablerChartArcs,
  tablerChartArcs3,
  tablerChartArea,
  tablerChartAreaLine,
  tablerChartArrows,
  tablerChartArrowsVertical,
  tablerChartBar,
  tablerChartBubble,
  tablerChartCandle,
  tablerChartCircles,
  tablerChartDonut,
  tablerChartDonut2,
  tablerChartDonut3,
  tablerChartDonut4,
  tablerChartDots,
  tablerChartInfographic,
  tablerChartLine,
  tablerChartPie,
  tablerChartPie2,
  tablerChartPie3,
  tablerChartPie4,
  tablerChartRadar,
  tablerCloud,

  // TIME / DATE
  tablerCalendar,
  tablerCalendarEvent,
  tablerCalendarMinus,
  tablerCalendarTime,
  tablerClock,

  // COMMUNICATION & MESSAGES
  tablerMessages,
  tablerMessageOff,
  tablerPrompt,
  tablerPhoneCall,
  tablerPhoneCalling,

  // BRAND / EXTERNAL SERVICES
  tablerBrandAirbnb,
  tablerBrandWhatsapp,

  // ANALYTICS / TARGETING / PRESENTATION
  tablerPresentationAnalytics,
  tablerReportAnalytics,
  tablerTarget,
  tablerFilter,
  tablerFilterOff,

  // ENERGY / POWER / INFRASTRUCTURE
  tablerChargingPile,
  tablerBatteryCharging,
  tablerBatteryAutomotive,
  tablerBatteryEco,
  tablerBatteryCharging2,
  tablerServer,
  tablerFlame,
  tablerFolder,

  // MOOD / EMOTION
  tablerMoodBoy,
  tablerMoodConfuzed,
  tablerMoodCrazyHappy,
  tablerMoodCry,
  tablerMoodEmpty,
  tablerMoodHappy,
  tablerMoodKid,
  tablerMoodNervous,
  tablerMoodNeutral,
  tablerMoodSad,
  tablerMoodSmile,
  tablerMoodSuprised,
  tablerMoodTongue,

  // LISTS / TEXT / TAGGING / IDENTITY
  tablerList,
  tablerListDetails,
  tablerListCheck,
  tablerChecks,
  tablerCheckupList,
  tablerFileText,
  tablerTag,
  tablerListNumbers,
  tablerHash,
  tablerAt,
  tablerFaceId,
  tablerUser,
  tablerHeadphones,
  tablerHeadset,
  tablerUserCircle,
  tablerDirection,
  tablerDirections,
  tablerCandy,
  tablerEraser,

  // LAYOUT / STRUCTURE
  tablerLayoutBoard,
  tablerLayoutBoardSplit,
  tablerLayout2,
  tablerLayout,
  tablerLayoutDashboard,
  tablerLayoutDistributeHorizontal,
  tablerLayoutDistributeVertical,
  tablerLayoutGrid,
  tablerLayoutGridAdd,
  tablerSitemap,
  tablerCategory2,

  // NAVIGATION / ARROWS / SORT
  tablerArrowsSort,
  tablerArrowUp,
  tablerArrowDown,

  // STATUS / MISC SYMBOLS
  tablerExclamationMark,
  tablerMinus,
  tablerAlien,
  tabler3dCubeSphere,
  tablerCheck,
  tablerRefresh,
  tablerFolderPlus,
  tablerArrowForwardUp,
  tablerArrowBackUp,
  tablerSearch,
  tablerX,
  tablerPlus,
  tablerEdit,
  tablerTrash,
  tablerTrashX,
  tablerDots,
  tablerLoader,
  tablerChevronUp,
  tablerChevronDown,
  tablerLayersIntersect,
  tablerLayersUnion,
  tablerBook2,
  tablerLanguage,
} from "@ng-icons/tabler-icons";

function stripSvgDesc(svg: string): string {
  // Tabler icon SVGs include a <desc> node like:
  // <desc>Download more icon variants from https://tabler-icons.io/i/...</desc>
  // If SVG rendering is broken/sanitized, that text can leak into the UI.
  return svg.replace(/<desc[^>]*>[\s\S]*?<\/desc>/gi, "");
}

function stripSvgDescs(
  iconMap: Record<string, string>,
): Record<string, string> {
  const result: Record<string, string> = {};

  for (const key of Object.keys(iconMap)) {
    result[key] = stripSvgDesc(iconMap[key]);
  }

  return result;
}

// GROUPED EXPORTS -----------------------------------------------------------
// Data Visualization (charts)
export const TABLER_VISUALIZATION_ICONS = {
  tablerChartArcs,
  tablerChartArcs3,
  tablerChartArea,
  tablerChartAreaLine,
  tablerChartArrows,
  tablerChartArrowsVertical,
  tablerChartBar,
  tablerChartBubble,
  tablerChartCandle,
  tablerChartCircles,
  tablerChartDonut,
  tablerChartDonut2,
  tablerChartDonut3,
  tablerChartDonut4,
  tablerChartDots,
  tablerChartInfographic,
  tablerChartLine,
  tablerChartPie,
  tablerChartPie2,
  tablerChartPie3,
  tablerChartPie4,
  tablerChartRadar,
  tablerCloud,
};

// Time & Date
export const TABLER_TIME_ICONS = {
  tablerCalendar,
  tablerCalendarEvent,
  tablerCalendarMinus,
  tablerCalendarTime,
  tablerClock,
};

// Communication
export const TABLER_COMMUNICATION_ICONS = {
  tablerMessages,
  tablerMessageOff,
  tablerPrompt,
  tablerPhoneCall,
  tablerPhoneCalling,
  tablerLanguage,
};

// Brand
export const TABLER_BRAND_ICONS = {
  tablerBrandAirbnb,
  tablerBrandWhatsapp,
};

// Analytics / Targeting
export const TABLER_ANALYTICS_ICONS = {
  tablerPresentationAnalytics,
  tablerReportAnalytics,
  tablerTarget,
  tablerFilter,
  tablerFilterOff,
};

// Infrastructure & Power
export const TABLER_INFRA_ICONS = {
  tablerChargingPile,
  tablerBatteryCharging,
  tablerBatteryAutomotive,
  tablerBatteryEco,
  tablerBatteryCharging2,
  tablerServer,
  tablerFlame,
  tablerFolder,
  tablerFolderPlus,
};

// Mood / Emotion
export const TABLER_MOOD_ICONS = {
  tablerMoodBoy,
  tablerMoodConfuzed,
  tablerMoodCrazyHappy,
  tablerMoodCry,
  tablerMoodEmpty,
  tablerMoodHappy,
  tablerMoodKid,
  tablerMoodNervous,
  tablerMoodNeutral,
  tablerMoodSad,
  tablerMoodSmile,
  tablerMoodSuprised,
  tablerMoodTongue,
};

// Lists / Text / Tagging / Identity
export const TABLER_TEXT_ICONS = {
  tablerCheck,
  tablerChecks,
  tablerList,
  tablerListDetails,
  tablerListCheck,
  tablerCheckupList,
  tablerFileText,
  tablerTag,
  tablerListNumbers,
  tablerHash,
  tablerAt,
  tablerFaceId,
  tablerUser,
  tablerHeadphones,
  tablerHeadset,
  tablerUserCircle,
  tablerCandy,
  tablerEraser,
};

// Directions / Navigation / Sorting
export const TABLER_DIRECTION_ICONS = {
  tablerDirection,
  tablerDirections,
  tablerArrowsSort,
  tablerArrowUp,
  tablerArrowDown,
  tablerArrowForwardUp,
  tablerArrowBackUp,
  tablerChevronUp,
  tablerChevronDown,
};

// Layout / Structure
export const TABLER_LAYOUT_ICONS = {
  tablerLayoutBoard,
  tablerLayoutBoardSplit,
  tablerLayout2,
  tablerLayout,
  tablerLayoutDashboard,
  tablerLayoutDistributeHorizontal,
  tablerLayoutDistributeVertical,
  tablerLayoutGrid,
  tablerLayoutGridAdd,
  tablerSitemap,
  tablerCategory2,
};

// Status / Miscellaneous
export const TABLER_STATUS_MISC_ICONS = {
  tablerExclamationMark,
  tablerMinus,
  tablerAlien,
  tabler3dCubeSphere,
  tablerLoader,
  tablerRefresh,
  tablerSearch,
  tablerX,
  tablerPlus,
  tablerEdit,
  tablerTrash,
  tablerTrashX,
  tablerDots,
  tablerLayersIntersect,
  tablerLayersUnion,
  tablerBook2,
};

// Consolidated export expected by the module registration
const TABLER_CHART_ICONS_RAW = {
  ...TABLER_VISUALIZATION_ICONS,
  ...TABLER_TIME_ICONS,
  ...TABLER_COMMUNICATION_ICONS,
  ...TABLER_BRAND_ICONS,
  ...TABLER_ANALYTICS_ICONS,
  ...TABLER_INFRA_ICONS,
  ...TABLER_MOOD_ICONS,
  ...TABLER_TEXT_ICONS,
  ...TABLER_DIRECTION_ICONS,
  ...TABLER_LAYOUT_ICONS,
  ...TABLER_STATUS_MISC_ICONS,
};

export const TABLER_CHART_ICONS = stripSvgDescs(TABLER_CHART_ICONS_RAW);
